// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.applications.RentalManagerPdfRendererWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias } from '../..';

interface GetPropertySheetPdfParams {
  listingAlias: ListingAlias;
}

export const RentalManagerPdfRendererWebApiHandler_getPropertySheetPdf_Path =
  '/api/web/v1/users/applications/getPropertySheetPdf';

export const RentalManagerPdfRendererWebApiHandler_getPropertySheetPdf = (
  getParams: GetPropertySheetPdfParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPropertySheetPdfParams, never, string>(
    {
      getParams: getParams,
      endpoint: RentalManagerPdfRendererWebApiHandler_getPropertySheetPdf_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
